import React, { useState } from 'react';
import { Flex, NativeSelect, Box } from '@builtbypixel/plasma';
import { File } from '@builtbypixel/nucleus';

const FileUpload = ({ name, onChange, value, ...rest }) => {
    const [mode, setMode] = useState('file');
    return (
        <Flex direction='column'>
            <Box maxWidth='200px' mb='10px'>
                <NativeSelect
                    size='sm'
                    value={mode}
                    onChange={(e) => setMode(e.target.value)}
                >
                    <option value='file'>File</option>
                    <option value='image'>Image</option>
                </NativeSelect>
            </Box>
            <File
                onChange={onChange}
                value={value}
                endpoint={
                    mode === 'file'
                        ? '/file-upload/document'
                        : '/file-upload/image'
                }
                {...rest}
            />
        </Flex>
    );
};

export default FileUpload;
